<template>
  <ul class="nav" v-if="filteredSidebarMenu">
    <li class="nav-header">Menu</li>
    <template v-for="menu in filteredSidebarMenu">
      <sidebar-nav-list
        ref="sidebarNavList"
        v-bind:menu="menu"
        v-bind:scrollTop="scrollTop"
        v-bind:key="menu.path"
        v-bind:status="menu.status"
        v-on:collapse-other="handleCollapseOther(menu)"
        v-on:show-float-submenu="handleShowFloatSubmenu"
        v-on:hide-float-submenu="handleHideFloatSubmenu"
      ></sidebar-nav-list>
    </template>
    <li class="mx-2 py-1 rounded-lg">
      <a href="https://lmsfkunisa.com" target="_blank">
        <div class="icon-img" style="border-radius: 0px">
          <img :src="require('@/assets/lms.svg')" />
        </div>
        <span> LMS </span>
      </a>
    </li>
  </ul>
</template>

<script>
// import { SidebarMenu } from "./SidebarMenu.js";
import axios from "axios";
import SidebarNavList from "./SidebarNavList.vue";
import PageOptions from "../../config/PageOptions.vue";
import userData from "../../plugins/userData";

export default {
  name: "SidebarNav",
  mixins: [userData],
  props: ["scrollTop"],
  components: {
    SidebarNavList,
  },
  data() {
    return {
      userLevel: "user",
      sidebarMenu: [],
      pageOptions: PageOptions,
    };
  },
  mounted() {
    axios
      .get("/v1/menus")
      .then((response) => {
        this.sidebarMenu = response.data;
        console.log(this.sidebarMenu);
      })
      .catch((error) => {
        this.error = error.message;
      });
  },
  methods: {
    handleShowFloatSubmenu: function (menu, offset) {
      this.$emit("show-float-submenu", menu, offset);
    },
    handleHideFloatSubmenu: function () {
      this.$emit("hide-float-submenu");
    },
    handleCollapseOther: function (menu) {
      for (var i = 0; i < this.filteredSidebarMenu.length; i++) {
        this.$refs.sidebarNavList[i].collapse(menu);
      }
    },
    handleSidebarMinify: function () {
      this.pageOptions.pageSidebarMinified =
        !this.pageOptions.pageSidebarMinified;
    },
    handleSidebarFilter: function (e) {
      var value = e.target.value;
      value = value.toLowerCase();

      if (value) {
        for (var x = 0; x < this.filteredSidebarMenu.length; x++) {
          var title = this.filteredSidebarMenu[x].title.toLowerCase();
          var children = this.filteredSidebarMenu[x].children;

          if (title.search(value) > -1) {
            this.$refs.sidebarNavList[x].show();

            if (children) {
              this.$refs.sidebarNavList[x].searchExpand();
            }
          } else {
            if (children) {
              var hasActive = false;
              for (var y = 0; y < children.length; y++) {
                var title2 = children[y].title.toLowerCase();

                if (title2.search(value) > -1) {
                  hasActive = true;
                  this.$refs.sidebarNavList[x].$refs.sidebarNavList[y].show();
                  this.$refs.sidebarNavList[x].searchExpand();
                } else {
                  if (hasActive) {
                    this.$refs.sidebarNavList[x].searchExpand();
                  } else {
                    this.$refs.sidebarNavList[x].hide();
                  }
                  this.$refs.sidebarNavList[x].$refs.sidebarNavList[y].hide();
                }
              }
            } else {
              this.$refs.sidebarNavList[x].hide();
            }
          }
        }
      } else {
        for (var a = 0; a < this.filteredSidebarMenu.length; a++) {
          this.$refs.sidebarNavList[a].show();

          var submenu = this.filteredSidebarMenu[a].children;
          if (submenu) {
            for (var b = 0; b < submenu.length; b++) {
              this.$refs.sidebarNavList[a].$refs.sidebarNavList[b].show();
            }
          }
        }
      }
      console.log("------");
    },
  },
  computed: {
    filteredSidebarMenu() {
      const userRoles = this.userLevel || [];

      const filterMenu = (menu) => {
        if (
          menu.roles &&
          !menu.roles.some((role) => userRoles.includes(role))
        ) {
          return false;
        }

        if (menu.children && menu.children.length > 0) {
          menu.children = menu.children.filter((child) => {
            const childRoles = child.roles || menu.roles;
            if (!childRoles) return true;
            return childRoles.some((role) => userRoles.includes(role));
          });
        }

        return true;
      };
      return JSON.parse(JSON.stringify(this.sidebarMenu)).filter(filterMenu);
    },
  },
};
</script>
<style>
.sidebar .sub-menu > li:after {
  content: "";
  position: absolute;
  left: 0;
  width: 6px;
  height: 6px;
  border: 1px solid rgba(255, 255, 255, 0.6);
  top: 11px;
  margin-top: 2px;
  z-index: 10;
  background: #2d353c;
  border-radius: 4px;
}
</style>
